export const imgFallback = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const { currentTarget } = e
    currentTarget.onerror = null // prevents looping
    currentTarget.src = '/flags/WORLD@2x.png'
}
